import Vue from "vue";
import Router from "vue-router";
import PolizaAutos from "@/components/Paginas/PolizaAutos.vue";
import Login from "@/components/Paginas/Login.vue";
import Inicio from "@/components/Paginas/Inicio.vue";
import SiniestroAutos from "@/components/Paginas/SiniestroAutos.vue";
import SiniestroHogar from "@/components/Paginas/SiniestroHogar.vue";
import SiniestroMovilidad from "@/components/Paginas/SiniestroMovilidad.vue";
import SiniestroNegocio from "@/components/Paginas/SiniestroNegocio.vue";
import SiniestroAccidentes from "@/components/Paginas/SiniestroAccidentes.vue";
import SiniestroMascotas from "@/components/Paginas/SiniestroMascotas.vue";
import Recibo from "@/components/Paginas/Recibo.vue";
import PolizaHogar from "@/components/Paginas/PolizaHogar.vue";
import Nif from "@/components/Paginas/Registro/Nif.vue";
import Telefono from "@/components/Paginas/Registro/Telefono.vue";
import Pin from "@/components/Paginas/Registro/Pin.vue";
import Claves from "@/components/Paginas/Registro/Claves.vue";
import ValidacionEmail from "@/components/Paginas/Registro/ValidacionEmail.vue";
import Email from "@/components/Paginas/Registro/Email.vue";
import Cliente from "@/components/Paginas/Cliente.vue";
import Gdpr from "@/components/Paginas/Registro/Gdpr.vue";
import GdprTacito from "@/components/Paginas/Registro/GdprTacito.vue";
import Beneficios from "@/components/Paginas/Beneficios.vue";
import Informacion from "@/components/Paginas/Informacion.vue";
import PolizaDecesos from "@/components/Paginas/PolizaDecesos.vue";
import AvisoRenovacion from "@/components/Paginas/AvisoRenovacion.vue";
import Ofertas from "@/components/Paginas/Ofertas.vue";
import MiOficina from "@/components/Paginas/MiOficina.vue";
import Servicios from "@/components/Paginas/Servicios.vue";
import Sorteos from "@/components/Paginas/Sorteos.vue";
import PolizaSalud from "@/components/Paginas/PolizaSalud.vue";
import PolizaSaludMMT from "@/components/Paginas/PolizaSaludMMT.vue";
import PolizaMovilidad from "@/components/Paginas/PolizaMovilidad.vue";
import PolizaNegocio from "@/components/Paginas/PolizaNegocio.vue";
import PolizaAccidentes from "@/components/Paginas/PolizaAccidentes.vue";
import PolizaMascotas from "@/components/Paginas/PolizaMascotas.vue";


Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  //scrollBehavior(to, from, savedPosition) {
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/inicio",
      name: "inicio",
      component: Inicio
    },
    {
      path: "/gdpr",
      name: "gdpr",
      component: Gdpr
    },
    {
      path: "/gdprTacito",
      name: "gdprTacito",
      component: GdprTacito
    },
    {
      path: "/nif",
      name: "registroNif",
      component: Nif,
      props: {
        titulo: "Nuevo Usuario"
      }
    },
    {
      path: "/nif",
      name: "registroNifRecordar",
      component: Nif,
      props: {
        titulo: "Recordar Contraseña"
      }
    },
    {
      path: "/telefono",
      name: "registroTelefono",
      component: Telefono
    },
    {
      path: "/pin",
      name: "registroPin",
      component: Pin
    },

    {
      path: "/claves",
      name: "registroClaves",
      component: Claves
    },

    {
      path: "/validEmail",
      name: "validEmail",
      component: ValidacionEmail
    },

    {
      path: "/email",
      name: "email",
      component: Email
    },

    {
      path: "/polizaAutos/:idPoliza",
      name: "polizaAutos",
      component: PolizaAutos
    },

    {
      path: "/siniestroAutos/:numSiniestro",
      name: "siniestroAutos",
      component: SiniestroAutos
    },

    {
      path: "/siniestroHogar/:numSiniestro",
      name: "siniestroHogar",
      component: SiniestroHogar
    },

    {
      path: "/siniestroMovilidad/:numSiniestro",
      name: "siniestroMovilidad",
      component: SiniestroMovilidad
    },

    {
      path: "/siniestroNegocio/:numSiniestro",
      name: "siniestroNegocio",
      component: SiniestroNegocio
    },

    {
      path: "/siniestroAccidentes/:numSiniestro",
      name: "siniestroAccidentes",
      component: SiniestroAccidentes
    },

    {
      path: "/siniestroMascotas/:numSiniestro",
      name: "siniestroMascotas",
      component: SiniestroMascotas
    },


    {
      path: "/recibo/:idRecibo",
      name: "recibo",
      component: Recibo
    },

    {
      path: "/polizaHogar/:idPoliza",
      name: "polizaHogar",
      component: PolizaHogar
    },

    {
      path: "/cliente",
      name: "cliente",
      component: Cliente
    },

    {
      path: "/servicios",
      name: "servicios",
      component: Servicios
    },

    {
      path: "/ofertas",
      name: "ofertas",
      component: Ofertas
    },

    {
      path: "/mioficina",
      name: "mioficina",
      component: MiOficina
    },

    {
      path: "/sorteos",
      name: "sorteos",
      component: Sorteos
    },

    {
      path: "/beneficios",
      name: "beneficios",
      component: Beneficios
    },
    {
      path: "/informacion",
      name: "informacion",
      component: Informacion
    },
    {
      path: "/polizaDecesos/:idPoliza",
      name: "polizaDecesos",
      component: PolizaDecesos
    },
    {
      path: "/avisoRenovacion/:idPoliza",
      name: "avisoRenovacion",
      component: AvisoRenovacion
    },
    {
      path: "/polizaSalud/:numPoliza",
      name: "polizaSalud",
      component: PolizaSalud
    },
    {
      path: "/polizaSaludMMT/:idPoliza",
      name: "polizaSaludMMT",
      component: PolizaSaludMMT
    },
    {
      path: "/polizaMovilidad/:idPoliza",
      name: "polizaMovilidad",
      component: PolizaMovilidad
    },
    {
      path: "/polizaNegocio/:idPoliza",
      name: "polizaNegocio",
      component: PolizaNegocio
    },
    {
      path: "/polizaAccidentes/:idPoliza",
      name: "polizaAccidentes",
      component: PolizaAccidentes
    },

    {
      path: "/polizaMascotas/:idPoliza",
      name: "polizaMascotas",
      component: PolizaMascotas
    },

  ]
});

export default router;
